import { IconActionGeo24 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { ControlButton } from '../ControlButton';

import styles from './GeoLocation.css';

type GeoLocationProps = {
  handleClick: VoidFunction;
  dataTestId?: string;
};

export const GeoLocation: FC<GeoLocationProps> = props => {
  const { handleClick } = props;

  return (
    <div className={styles['geo-location-button-wrapper']}>
      <ControlButton
        handleClick={handleClick}
        icon={<IconActionGeo24 color="icon-primary-default" />}
        testId="map-controls.geo-location"
        tooltipTitle="Моё местоположение"
      />
    </div>
  );
};
